import { Stack } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

import { ActivityMonitorTab } from '../../../components';

const Page = () => {
  const params = Route.useParams();
  return (
    <Stack sx={{ flex: 1, minHeight: 0 }}>
      <ActivityMonitorTab
        advisoryOrganizationId={params.advisoryOrganizationId}
        mode='org'
      />
    </Stack>
  );
};

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/activity-monitor'
)({
  component: Page
});
